import { render, staticRenderFns } from "./AttachmentCountBadge.vue?vue&type=template&id=55ab35ce&scoped=true&"
import script from "./AttachmentCountBadge.vue?vue&type=script&lang=js&"
export * from "./AttachmentCountBadge.vue?vue&type=script&lang=js&"
import style0 from "./AttachmentCountBadge.vue?vue&type=style&index=0&id=55ab35ce&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55ab35ce",
  null
  
)

export default component.exports